import { createContext } from "react";

export const StateContext = createContext(null);
